import React from 'react';
import Button from 'material-ui/Button/Button';
import Console from '../../../lib/debug';

const SecondaryButton = props => {
    Console.render('SecondaryButton');
    const disabledStyle = props.disabled ? ' disabled' : '';
    const outlinedVariant =
        props.variant && props.variant === 'outlined'
            ? ' th-secondary-button--outlined'
            : '';

    return (
        <Button
            className={`th-secondary-button${disabledStyle}${outlinedVariant}`}
            onClick={props.onClick}
            disabled={props.disabled}
            href={props.href}
        >
            {props.children}
        </Button>
    );
};

export default SecondaryButton;
